export default __webpack_public_path__ + "static/14-ed83a858cde5911cea961da38d94a19b.png";